<template>
  <Modal :title="id ? '编辑模版' : '新增模版'" @cancel="cancelHandle" @submit="submitHandle">
    <el-form :model="form" label-position="top">
      <div class="tebodyitem">
        <el-form-item label="模版类型" required>
          <el-select v-model="editorAppCode" placeholder="请选择" clearable :disabled="!!id">
            <el-option v-for="(itm, idx) in editorAppCodeList" :label="itm.label" :value="itm.value" :key="idx" />
          </el-select>
        </el-form-item>
        <el-form-item label="模版名称" required>
          <el-input v-model="form.templateName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="使用范围" required>
          <el-select v-model="form.useMode" placeholder="请选择" clearable>
            <el-option v-for="(itm, idx) in Object.keys(CONST.USE_MODE_LABEL).map(v => ({ value: Number(v), label: CONST.USE_MODE_LABEL[v] }))" :label="itm.label" :value="itm.value" :key="idx" />
          </el-select>
        </el-form-item>
      </div>
      <div class="tebodyitem double">
        <el-form-item label="备注">
          <el-input v-model="form.note" placeholder="请输入" clearable />
        </el-form-item>
      </div>

      <!--查询运价-->
      <template v-if="[ CONST.APP_CODE_QUERY_PRICE_QQ_QQS, CONST.APP_CODE_QUERY_PRICE_QQ ].includes(editorAppCode)">
        <QueryPrice :appCode="editorAppCode" :data="data" :carrier="carrier" @change="_form => form = { ...form, ..._form }" />
      </template>

      <!--查询船期-->
      <template v-if="editorAppCode == CONST.APP_CODE_QUERY_SCHEDULE">
        <QuerySchedule :data="data" @change="_form => form = { ...form, ..._form }" />
      </template>

      <!--批量订舱-->
      <template v-if="editorAppCode == CONST.APP_CODE_BOOKING">
        <Booking :data="data" @change="_form => form = { ...form, ..._form }" />
      </template>

      <!--BC解析-->
      <template v-if="editorAppCode == CONST.APP_CODE_BC_PARSE">
        <BcParse :data="data" @change="_form => form = { ...form, ..._form }" />
      </template>

      <!--批量退关-->
      <template v-if="editorAppCode == CONST.APP_CODE_CANCEL_BOOKING">
        <CancelBooking :data="data" @change="_form => form = { ...form, ..._form }" />
      </template>

      <!--自动订舱及查询预配-->
      <template v-if="editorAppCode == CONST.APP_CODE_EPTRADE_QUERY_SMA_EXCEL">
        <EptradeQueryCmaExcel :data="data" @change="_form => form = { ...form, ..._form }" />
      </template>
    </el-form>
  </Modal>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, CirclePlus, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Modal from '@/components/modal';
  import BcParse from './bcParse.vue';
  import Booking from './booking.vue';
  import CancelBooking from './cancelBooking.vue';
  import EptradeQueryCmaExcel from './eptradeQueryCmaExcel.vue';
  import QueryPrice from './queryPrice.vue';
  import QuerySchedule from './querySchedule.vue';
  import * as Request from '@/assets/request'
  import * as CONST from '@/assets/const'
  import moment from 'moment';
  import { ElMessage } from 'element-plus';

  const emits = defineEmits(['cancel', 'refresh'])

  const props = defineProps({
    carrier: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    appCode: {
      type: String,
      default: ''
    },
    apps: {
      type: Array,
      default: []
    }
  })
console.log('index.vue', props);
  const editorAppCodeList = ref([]);
  const initEditorAppCodeList = () => {
    // Object.keys(CONST.APP_CODE_LABEL).map(v => {
    //   if(v != CONST.APP_CODE_QUERY_TRACKER) {
    //     editorAppCodeList.value.push({ value: v, label: CONST.APP_CODE_LABEL[v].name })
    //   }
    // })
    props.apps.map(app => {
      if(app?.appCode && app?.appCode != 'all') {
        console.log('jinlai?? ---');
        editorAppCodeList.value.push({ value: app?.appCode, label: app?.appCodeName })
      }
    })
  }
  onMounted(() => {
    initEditorAppCodeList();
  })
  watch(() => props.apps, () => {
    initEditorAppCodeList();
  }, { deep: true });
  const editorAppCode = ref('');
  const initEditorAppCode = () => {
    editorAppCode.value = props.appCode;
  }
  onMounted(() => {
    initEditorAppCode()
  })
  watch(() => props.appCode, () => {
    initEditorAppCode()
  }, { deep: true });
  
  const data = ref(null)
  const getData = async () => {
    const { id, carrier } = props;
    if(!editorAppCode.value) return;

    const result = await Request.post({
      url: CONST.APP_CODE_LABEL[editorAppCode.value]?.getAction,
      data: { carrierCode: carrier, id }
    });
    if(result?.code != 200) return;

    data.value = result?.data;

    form.value.note = data.value?.note;
    form.value.templateName = data.value?.templateName;
    form.value.useMode = data.value?.useMode;
  }
  onMounted(() => {
    getData()
  })
  watch(() => editorAppCode.value, () => {
    getData()
  })
  
  /**
   * 表单
   */
  const form = ref({
    appCode: props.appCode || CONST.APP_CODE_QUERY_PRICE_QQ
  })

  // 根据 app code 获取提交需要的 app 信息
  const getAppByAppCode = async (appCode) => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    })
    if(result?.code != 200) return;

    let target = null
    if(result?.data?.length > 0) {
      result.data.map(item => {
        if(item?.apps?.length > 0) {
          item.apps.map(_item => {
            if(_item?.appCode == appCode) {
              target = _item;
            }
          })
        }
      })
    }

    return target
  }

  // 取消
  const cancelHandle = () => {
    emits('cancel')
  }

  const submitVerifyByAppCode = () => {
    const submitObj = { ...form.value }
    const appCode = editorAppCode.value;
    console.log('submitObj-----', submitObj)
    
    // 所有的
    if(!submitObj?.templateName) {
      ElMessage.error('请输入模版名称');
      return false;
    };
    if(submitObj?.useMode != 0 && !submitObj?.useMode) {
      ElMessage.error('请选择使用范围');
      return false;
    }
    
    // 查询运价
    if([ CONST.APP_CODE_QUERY_PRICE_QQ_QQS, CONST.APP_CODE_QUERY_PRICE_QQ ].includes(appCode)) {
      if(JSON.stringify(submitObj?.retrieveCostItems) == '[]') {
        ElMessage.error('请选择获取费用项');
        return false;
      }
      if(JSON.stringify(submitObj?.chargeItemVOS) == '[]') {
        ElMessage.error('请选择计总费用项');
        return false;
      }
    }
    // 查询船期
    if([ CONST.APP_CODE_QUERY_SCHEDULE ].includes(appCode)) {
      if(!submitObj?.optionalFields || JSON.stringify(submitObj?.optionalFields) == '[]') {
        ElMessage.error('请选择船期信息项');
        return false;
      }
    }
    // 批量订舱
    if([ CONST.APP_CODE_BOOKING ].includes(appCode)) {
      if(!submitObj?.mail) {
        ElMessage.error('请输入BC接收邮箱');
        return false;
      }
      if(submitObj?.weights?.length == 0 || submitObj?.weights.some(item => !item.containerType || !item.weight)) {
        ElMessage.error('请补充完整箱型-箱重映射关系');
        return false;
      }
      if(submitObj?.products?.length == 0 || submitObj?.products.some(item => !item.containerType || !item.product)) {
        ElMessage.error('请补充完整箱型-品名映射关系');
        return false;
      }
      if(submitObj?.hscodeNeed && (submitObj?.hsCodes?.length == 0 || submitObj?.hsCodes.some(item => !item.hsCode || !item.productCode))) {
        ElMessage.error('请补充完整品名-HSCODE映射关系');
        return false;
      }
    }
    // BC解析
    if([ CONST.APP_CODE_BC_PARSE ].includes(appCode)) {
      if(!submitObj?.host) {
        ElMessage.error('请输入邮箱IMAP服务器');
        return false;
      }
      if(!submitObj?.username) {
        ElMessage.error('请输入邮箱账号');
        return false;
      }
      if(!submitObj?.password) {
        ElMessage.error('请输入邮箱授权码');
        return false;
      }
      if(!submitObj?.fields || JSON.stringify(submitObj?.fields) == '[]') {
        ElMessage.error('请选择结果文件信息');
        return false;
      }
    }
    // 批量退关
    if([ CONST.APP_CODE_CANCEL_BOOKING ].includes(appCode)) {
      if(!submitObj?.email) {
        ElMessage.error('请输入退关通知接收邮箱');
        return false;
      }
    }
    
    return true;
  }

  // 保存
  const submitHandle = async () => {
    if(!submitVerifyByAppCode()) return;

    const submitObj = { ...form.value }
    const appCode = editorAppCode.value;
    const appInfo = await getAppByAppCode(appCode)
    submitObj.appId = appInfo?.id;
    
    console.log('submit ---------', submitObj);
    // return
    if(props?.id) submitObj.id = props?.id;

    const url = CONST.APP_CODE_LABEL[appCode]?.saveAction;
    const result = await Request.post({ url, data: submitObj });
    if(result?.code != 200) return;

    ElMessage.success('添加成功');
    emits('refresh')
    cancelHandle();
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>